// extracted by mini-css-extract-plugin
export default {"settingsContainer":"style_settingsContainer__MmqZU","logo":"style_logo__ta0C8"};